// extracted by mini-css-extract-plugin
export default {"campaigns":"Campaigns_campaigns__tsnUg","focusAreaBtn":"Campaigns_focusAreaBtn__0sjf-","swiperBullet":"Campaigns_swiperBullet__j9+QH","swiperImg":"Campaigns_swiperImg__5d2CH"};